import React from "react";
import { Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import NumberFormat from "react-number-format";
import "./style.scss";
import Text from "../../../../../library/text";

const Index = () => {
  const details = useSelector((state) => state.singleList.activeDisplay);
  const loading = useSelector(
    (state) => state.singleList.fetchSingleDetails.loading
  );

  return (
    <div className="single-client-details-tab-container">
      <div className="all-details-container">
        <Row className="company-details-row">
          <Col className="company-left-col">
            <h3 className="section-title">Bedriftsinformasjon</h3>
            <Text>
              Nedenfor finner du informasjon relatert til bedriften som er
              hentet fra offentlige registre.
            </Text>
            <Row className="single-information-row">
              <Col className="information-col text-left">
                <label className="label-title">Organisasjonsnummer</label>
              </Col>
              <Col className="information-col text-right">
                <label className="label-data">
                  {loading ? (
                    <i className="fas fa-circle-notch fa-spin"></i>
                  ) : null}{" "}
                  <NumberFormat
                    format="### ### ###"
                    displayType={"text"}
                    value={!loading && details.general.organizationNumber}
                  />{" "}
                  {!details.general.organizationNumber &&
                    !loading &&
                    "Utilgjengelig"}
                </label>
              </Col>
            </Row>
            <Row className="single-information-row">
              <Col className="information-col text-left">
                <label className="label-title">Antall ansatte</label>
              </Col>
              <Col className="information-col text-right">
                <label className="label-data">
                  {loading ? (
                    <i className="fas fa-circle-notch fa-spin"></i>
                  ) : null}{" "}
                  {details.general.employees}{" "}
                  {!details.general.employees && !loading && "Utilgjengelig"}
                </label>
              </Col>
            </Row>
            <Row className="single-information-row">
              <Col className="information-col text-left">
                <label className="label-title">Aksjekapital</label>
              </Col>
              <Col className="information-col text-right">
                <label className="label-data">
                  {loading ? (
                    <i className="fas fa-circle-notch fa-spin"></i>
                  ) : null}{" "}
                  <NumberFormat
                    value={!loading && details.general.shareCapital}
                    displayType={"text"}
                    thousandSeparator={" "}
                  />{" "}
                  {!details.general.shareCapital && !loading && "Utilgjengelig"}
                </label>
              </Col>
            </Row>
            <Row className="single-information-row">
              <Col className="information-col text-left">
                <label className="label-title">Kredittverdighet</label>
              </Col>
              <Col className="information-col text-right">
                <label className="label-data">
                  {loading ? (
                    <i className="fas fa-circle-notch fa-spin"></i>
                  ) : null}{" "}
                  {details.financials.description}{" "}
                  {!details.financials.description &&
                    !loading &&
                    "Utilgjengelig"}
                </label>
              </Col>
            </Row>
            <Row className="single-information-row bottom">
              <Col className="information-col text-left">
                <label className="label-title">Kredittvurdering</label>
              </Col>
              <Col className="information-col text-right">
                <label className="label-data">
                  {loading ? (
                    <i className="fas fa-circle-notch fa-spin"></i>
                  ) : null}{" "}
                  {details.financials.rating}{" "}
                  {!details.financials.rating && !loading && "Utilgjengelig"}
                </label>
              </Col>
            </Row>
          </Col>
          <Col className="company-right-col">
            <h3 className="section-title">Kontaktinformasjon</h3>
            <Text>
              Informasjonen kan være feil dersom bedriften eller vedkommende
              nylig har endret dette.
            </Text>
            <Row className="single-information-row">
              <Col className="information-col text-left">
                <label className="label-title">Telefon</label>
              </Col>
              <Col className="information-col text-right">
                <label className="label-data">
                  <a
                    href={`${
                      details.contact.phone ? details.contact.phone : "#"
                    }`}
                  >
                    {loading ? (
                      <i className="fas fa-circle-notch fa-spin"></i>
                    ) : null}{" "}
                    {details.contact.phone && "Ring nummer"}{" "}
                    {!details.contact.phone && !loading && "Utilgjengelig"}
                  </a>
                </label>
              </Col>
            </Row>
            <Row className="single-information-row">
              <Col className="information-col text-left">
                <label className="label-title">E-post</label>
              </Col>
              <Col className="information-col text-right">
                <label className="label-data">
                  <a
                    href={`${
                      details.contact.email ? details.contact.email : "#"
                    }`}
                  >
                    {loading ? (
                      <i className="fas fa-circle-notch fa-spin"></i>
                    ) : null}{" "}
                    {details.contact.email && "Send e-post"}{" "}
                    {!details.contact.email && !loading && "Utilgjengelig"}
                  </a>
                </label>
              </Col>
            </Row>
            <Row className="single-information-row">
              <Col className="information-col text-left">
                <label className="label-title">Facebook</label>
              </Col>
              <Col className="information-col text-right">
                <label className="label-data">
                  <a
                    href={`${
                      details.social.facebook ? details.social.facebook : "#"
                    }`}
                  >
                    {loading ? (
                      <i className="fas fa-circle-notch fa-spin"></i>
                    ) : null}{" "}
                    {details.social.facebook && "Gå til side"}{" "}
                    {!details.social.facebook && !loading && "Utilgjengelig"}
                  </a>
                </label>
              </Col>
            </Row>
            <Row className="single-information-row">
              <Col className="information-col text-left">
                <label className="label-title">Twitter</label>
              </Col>
              <Col className="information-col text-right">
                <label className="label-data">
                  <a
                    href={`${
                      details.social.twitter ? details.social.twitter : "#"
                    }`}
                  >
                    {loading ? (
                      <i className="fas fa-circle-notch fa-spin"></i>
                    ) : null}{" "}
                    {details.social.twitter && "Gå til side"}{" "}
                    {!details.social.twitter && !loading && "Utilgjengelig"}
                  </a>
                </label>
              </Col>
            </Row>
            <Row className="single-information-row bottom">
              <Col className="information-col text-left">
                <label className="label-title">Hjemmeside</label>
              </Col>
              <Col className="information-col text-right">
                <label className="label-data">
                  <a
                    href={`${
                      details.contact.website ? details.contact.website : "#"
                    }`}
                  >
                    {loading ? (
                      <i className="fas fa-circle-notch fa-spin"></i>
                    ) : null}{" "}
                    {details.contact.website && "Gå til side"}{" "}
                    {!details.contact.website && !loading && "Utilgjengelig"}
                  </a>
                </label>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Index;
